// extracted by mini-css-extract-plugin
export var banner = "_si-0";
export var settingRow = "_si-2";
export var titleIcon = "_si-1";